import { ReportAPI, TicketAPI } from 'api'
import { IRealTimeQueryConfig } from 'api/report/realTime/types'
import { mapResponse } from 'utils/api'

import { IQueryOptions } from '../query/types'

import { parseTicketsCreatedByRep } from './parsers'
import { getQuery } from './queries'

export const fetchSearch = (
  queryConfig: IRealTimeQueryConfig,
  options?: IQueryOptions
) => {
  const { query } = getQuery(queryConfig, options)

  return ReportAPI.post('/conversation-summary/search', query)
    .then(mapResponse)
    .then((response) => response)
}

export const fetchSimpleReport = (
  queryConfig: IRealTimeQueryConfig,
  options?: IQueryOptions
) => {
  const { query, parseFunction } = getQuery(queryConfig, options)

  return ReportAPI.post('/conversation-summary/report/simple', query)
    .then(mapResponse)
    .then((response) => parseFunction(response, queryConfig, options))
}

export const fetchMeetingReport = (
  queryConfig: IRealTimeQueryConfig,
  options?: IQueryOptions
) => {
  const { query, parseFunction } = getQuery(queryConfig, options)

  return ReportAPI.post('/scheduling-event-summary/report/simple', query)
    .then(mapResponse)
    .then((response) => parseFunction(response, queryConfig, options))
}

export const fetchTicketsData = (orgId: number) => {
  const start = new Date()
  start.setUTCHours(0, 0, 0, 0)

  const end = new Date()
  end.setUTCHours(23, 59, 59, 999)

  return TicketAPI.get(
    `/ticket/org/${orgId}/startTime/${start.getTime()}/endTime/${end.getTime()}`
  )
    .then(mapResponse)
    .then((response) => parseTicketsCreatedByRep(response))
}

export const fetchReportExport = (
  queryConfigs: IRealTimeQueryConfig[],
  columns: string[],
  exportKey: string,
  filterState,
  options?: IQueryOptions
) => {
  const queries = queryConfigs.map((queryConfig) => {
    const queryAndParse = getQuery(queryConfig, options)
    return queryAndParse.query
  })
  // TODO @cmcgorrill - put this back in after BE can support filtering on the firstRoutingAction.participants property
  // const queryWithUIFilters = appendUIFiltersToQuery(query, queryConfig.metric, filterState)
  const exportRequest = { exportKey, query: queries, columns }

  return ReportAPI.post(
    `/conversation-summary/report/simple/export`,
    exportRequest
  ).then(mapResponse)
}
